import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Container from '@material-ui/core/Container';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { IStateList, ListComponent, TableCellSortable } from 'components/Abstract/List';
import Toolbar from 'components/Layout/Toolbar';
import FabButton from 'components/Shared/FabButton';
import TableWrapper from 'components/Shared/TableWrapper';
import { IPaginationParams } from 'interfaces/pagination';
import { IUser } from 'interfaces/user';
import AccountPlusIcon from 'mdi-react/AccountPlusIcon';
import RefreshIcon from 'mdi-react/RefreshIcon';
import React, { Fragment } from 'react';
import rxjsOperators from 'rxjs-operators';
import userService from 'services/user';

import UserFormDialog from '../UserFormDialog';
import ListItem from './ListItem';

interface IState extends IStateList<IUser> {
  current?: IUser;
  formOpened?: boolean;
}

export default class UserListPage extends ListComponent<{}, IState> {
  constructor(props: {}) {
    super(props, 'fullName');
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = (params: Partial<IPaginationParams> = {}) => {
    this.setState({ loading: true, error: null });

    userService.list(this.mergeParams(params)).pipe(
      rxjsOperators.logError(),
      rxjsOperators.bindComponent(this)
    ).subscribe(items => {
      this.setPaginatedData(items);
    }, error => this.setError(error));
  }

  onClickRefresh = () => this.loadData();

  handleCreate = () => {
    this.setState({ formOpened: true, current: null });
  }

  handleEdit = (current: IUser) => {
    this.setState({ formOpened: true, current });
  }

  formCallback = (user?: IUser) => {
    this.setState({ formOpened: false });

    this.state.current ?
      this.loadData() :
      this.handleChangeTerm(user.email);
  }

  formCancel = () => {
    this.setState({ formOpened: false });
  }

  render() {
    const { items, formOpened, loading, current } = this.state;

    return (
      <Fragment>
        <Toolbar title='Usuários' breadcrumbs={[{ title: 'Configurações' }, { title: 'Gestão de Acesso' }]} />
        <UserFormDialog
          opened={formOpened || false}
          user={current}
          onComplete={this.formCallback}
          onCancel={this.formCancel} />
        <Container>
          <Card>
            {this.renderLoader()}
            <CardContent>
              <Grid container justify="space-between">
                <Grid item xs sm={8} lg={4}>
                  {this.renderSearch()}
                </Grid>
                <Grid item xs='auto'>
                  <FabButton actions={[{
                    icon: AccountPlusIcon,
                    onClick: this.handleCreate
                  }]} />
                </Grid>
                <Grid item xs={12}>
                  <TableWrapper minWidth={500}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCellSortable {...this.sortableProps} column='fullName'>
                            Nome
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='email'>
                            Email
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='ventureId'>
                            Empreendimento(s)
                          </TableCellSortable>
                          <TableCellSortable {...this.sortableProps} column='roles'>
                            Perfil
                          </TableCellSortable>
                          <TableCell>
                            <IconButton disabled={loading} onClick={this.onClickRefresh}>
                              <RefreshIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.renderEmptyAndErrorMessages(5)}
                        {items.map(user =>
                          <ListItem
                            key={user.id}
                            user={user}
                            onEdit={this.handleEdit}
                            onDeleteComplete={this.loadData}
                          />
                        )}
                      </TableBody>
                    </Table>
                  </TableWrapper>
                  {this.renderTablePagination()}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </Fragment>
    );
  }
}